import React from 'react'

export const Footer = () => {
  return (
    <div className='py-4' style={containerStyle}>
        <div className='page-container items-center'>
            <p className='text-[#282828] text-base font-medium'>© 2025 StarFor All Rights Reserved.</p>
        </div>
    </div>
  )
}

const containerStyle = {
    borderTop: "1px solid #CFCFCF",
    background: "linear-gradient(180deg, #FFF 0%, #F2F2F2 100%)"
}